module.exports = __webpack_public_path__ + "img/illustration_bas.33b350b7.svg";